import React, { useContext } from 'react';
import AnnonceContext from '../../../../contexts/AnnonceContext';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import Avatar from '@mui/material/Avatar';

import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
import Step5 from './Step5';
import { notifyErrorEmpty } from 'src/service/notificationService';
import { setDate } from 'date-fns';

export default function CustomStepper({ children }) {
  const { activeStep, setActiveStep, formAnnonce, currentCategory, setFormAnnonce, imageUpload } = useContext(AnnonceContext);
  const filterCategory = currentCategory?.attribute.filter((c) => c.isSecret === false);
  const secretCategory = currentCategory?.attribute.filter((c) => c.isSecret === true);
  const status = formAnnonce.status.toLowerCase();
  const steps = ['Photo et détails', 'Date et Lieu', `Objet ${status}`, 'Infos secretes', 'Stockage'];
  const stepDescription = [
    'Ajouter une photo',
    `Quand ?`,
    `Quoi ?`,
    "Détails Secrets",
    "Stockage"
  ];
  const stepComponent = [<Step3 />, <Step1 />, <Step2 />, <Step4 />, <Step5/>];

  const missingAttributeName = (requiredAttribute, annonceAttribute) => {
    const missingAttribute = requiredAttribute.map((r) => {
      const finds = annonceAttribute.find((a) => {
        if (a.attribute === r.name) {
          return true;
        }
        return false;
      })
      if (finds)
        return null
      return r.name
    })
    return missingAttribute
  }

  const checkAttribute = () => {
    if (currentCategory === undefined || filterCategory === undefined) {
      notifyErrorEmpty(["catégorie"])
      return false
    }

    const requiredAttribute = filterCategory.filter((c) => c.isRequired === true);
    const annonceAttribute = formAnnonce.annonceAttributes;

    let missingAttribute = missingAttributeName(requiredAttribute, annonceAttribute)

    if (requiredAttribute.length > annonceAttribute.length) {
      if (missingAttribute.length > 0) {
        notifyErrorEmpty(missingAttribute)
      }
      return false
    }

    const requiredAnnonce = annonceAttribute.filter((a) => {
      if (a.attributeValue === undefined || a.attributeValue === '' || a.attributeValue === null)
        return false
      const finds = requiredAttribute.find((r) => {
        if (a.attribute === r.name) {
          return true;
        }
        return false;
      })
      if (finds)
        return true
      return false
    })

    if (currentCategory.name === "Smartphone") {
      const brand = requiredAnnonce.find((a) => a.attribute === "Marque Smartphone")
      if (!brand) {
        const otherBrand = annonceAttribute.find((a) => a.attribute === "Autre marque de Smartphone")
        if (otherBrand)
          requiredAnnonce.push(otherBrand)
      }
    }

    missingAttribute = missingAttributeName(requiredAttribute, requiredAnnonce)

    if (requiredAnnonce.length !== requiredAttribute.length) {
      if (missingAttribute.length > 0) {
        notifyErrorEmpty(missingAttribute)
      }
      return false
    }
    
    return true
  }

  const checkSecret = () => {
    if (currentCategory === undefined || filterCategory === undefined) {
      notifyErrorEmpty(["catégorie"])
      return false
    }

    const secretAttribute = secretCategory.filter((c) => c.isRequired === true);
    const annonceAttribute = formAnnonce.annonceAttributes;

    let missingAttribute = missingAttributeName(secretAttribute, annonceAttribute)

    if (secretAttribute.length > annonceAttribute.length) {
      if (missingAttribute.length > 0) {
        notifyErrorEmpty(missingAttribute)
      }
      return false
    }

    const requiredAnnonce = annonceAttribute.filter((a) => {
      if (a.attributeValue === undefined || a.attributeValue === '' || a.attributeValue === null)
        return false
      const finds = secretAttribute.find((r) => {
        if (a.attribute === r.name) {
          return true;
        }
        return false;
      })
      if (finds)
        return true
      return false
    })

    if (currentCategory.name === "Vêtements") {
      const brand = requiredAnnonce.find((a) => a.attribute === "Marque de vêtement")
      if (!brand) {
        const otherBrand = annonceAttribute.find((a) => a.attribute === "Autre marque de vêtements")
        if (otherBrand)
          requiredAnnonce.push(otherBrand)
      }
    }
    
    missingAttribute = missingAttributeName(secretAttribute, requiredAnnonce)

    if (requiredAnnonce.length !== secretAttribute.length) {
      if (missingAttribute.length > 0) {
        notifyErrorEmpty(missingAttribute)
      }
      return false
    }
    return true
  }

  const checkRequired = () => {
    const day = new Date();
    if (formAnnonce.date === undefined || formAnnonce.date === '') {
      setFormAnnonce({ ...formAnnonce, date: day.toISOString()});
      return true;
    }
    if (activeStep === 2 && !checkAttribute()) {
      return false
    }
    if (activeStep === 3 && !checkSecret()) {
     return false; 
    }
    return true
  }

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleNext = () => {
    if (!checkRequired())
      return
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  return (
    <div className="w-full mx-auto">
      <div className="bg-white rounded-lg p-4 md:p-8 min-h-[600px]">
        {/* Avatar image uploadée, sauf au premier step */}
        {imageUpload && activeStep !== 0 && (
          <div className="flex justify-center mb-4">
            <Avatar
              src={typeof imageUpload === 'string' ? imageUpload : URL.createObjectURL(imageUpload)}
              alt="Aperçu"
              sx={{ width: 80, height: 80, boxShadow: 2, border: '2px solid #1b9faa' }}
            />
          </div>
        )}
        {/* Stepper */}
        <div className="flex items-center justify-between mb-8">
          {steps.map((step, index) => (
            <div key={index} className="flex items-center">
              <div className={`flex items-center justify-center w-8 h-8 rounded-full ${
                index <= activeStep ? 'bg-[#1b9faa] text-white' : 'bg-gray-200 text-gray-600'
              }`}>
                {index + 1}
              </div>
              <span className={`ml-2 text-sm md:text-base ${
                index <= activeStep ? 'text-[#1b9faa]' : 'text-gray-500'
              }`}>
                {step}
              </span>
              {index < steps.length - 1 && (
                <ChevronRightIcon className="w-5 h-5 mx-2 text-gray-400" />
              )}
            </div>
          ))}
        </div>

        {/* Step Description */}
        <h2 className="text-2xl font-bold mb-8">
          {stepDescription[activeStep]}
        </h2>

        {/* Step Content */}
        {stepComponent[activeStep]}
        {children}

        {/* Navigation Buttons */}
        <div className="flex justify-between mt-8">
          <button
            onClick={handleBack}
            disabled={activeStep === 0}
            className={`px-6 py-2 rounded-md ${
              activeStep === 0
                ? 'bg-gray-300 cursor-not-allowed'
                : 'bg-[#1b9faa] text-white hover:bg-[#15808a]'
            }`}
          >
            Précédent
          </button>
          <button
            onClick={handleNext}
            disabled={activeStep === steps.length - 1}
            className={`px-6 py-2 rounded-md ${
              activeStep === steps.length - 1
                ? 'bg-gray-300 cursor-not-allowed'
                : 'bg-[#1b9faa] text-white hover:bg-[#15808a]'
            }`}
          >
            Suivant
          </button>
        </div>
      </div>
    </div>
  );
}
